var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8816 0.333984H2.19737C1.40132 0.333984 0.75 1.00898 0.75 1.83398V12.334H2.19737V1.83398H10.8816V0.333984ZM10.1579 3.33398L14.5 7.83398V15.334C14.5 16.159 13.8487 16.834 13.0526 16.834H5.08487C4.28882 16.834 3.64474 16.159 3.64474 15.334L3.65197 4.83398C3.65197 4.00898 4.29605 3.33398 5.09211 3.33398H10.1579ZM9.43421 8.58398H13.4145L9.43421 4.45898V8.58398Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fb241b3b10635e6a79f88b2115205fbd.svg";
export { ForwardRef as ReactComponent };